import { render, staticRenderFns } from "./AddOfficers.vue?vue&type=template&id=404acbfc&"
import script from "./AddOfficers.vue?vue&type=script&lang=js&"
export * from "./AddOfficers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports